








/* Created- 25 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import { ButtonConfig, ButtonType } from "../Models/Buttons";

import ParticaBaseView from "../Views/Base/ParticaBaseView.vue";
import ForgotPasswordForm from "@/Ui-Components/Account/ForgotPasswordForm.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { AccountClient } from "../Generated/ParticaAPI";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";

@Component(
	{
		name: "ForgottenPassword",
		components: { ForgottenPassword, ForgotPasswordForm, ParticaError, ParticaRowContainer, ParticaCard }
	})
export default class ForgottenPassword extends ParticaBaseView {
	private accountService: AccountClient;
	private email: string = "";
	private forgotbuttons: ButtonConfig[] = [
		{ label: "Re-Send welcome email", action: eParticaAction.ACCOUNT_RESEND_WELCOME, type: ButtonType.OK } as ButtonConfig
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.ACCOUNT_RESEND_WELCOME: {
					await this.accountService.resendWelcomeEmail(event.item, location.protocol + "//" + location.host);
					this.ShowSnackbar("Check your email for welcome email.");
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	private async mounted() {
		this.accountService = new AccountClient();
	}
}
